/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Lots_Create_PnkInputs */

const vi_scl_lots_create_pnk = /** @type {(inputs: Scl_Lots_Create_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu nhập`)
};

/**

* @param {Scl_Lots_Create_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_lots_create_pnk = /** @type {((inputs?: Scl_Lots_Create_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Lots_Create_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_lots_create_pnk(inputs)
});